import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {},
  contentContainer: {
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
  },

  backgroundContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
    height: '100%',
  },
  backgroundImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    maxWidth: 600,
    height: '100%',
  },
  overlayContent: {
    position: 'absolute',
    bottom: 100,
    left: 40,

    border: '2px solid white',
    borderRadius: 4,
    color: 'white',

    paddingTop: 10,
    paddingBottom: 22,
    paddingLeft: 10,
    paddingRight: 10,

    width: 241,
  },

  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 900,
    marginBottom: 5,
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.2,
  },
});
